export default "__VITE_ASSET__DznCsT8u__"